import gql from 'graphql-tag';

export const RECEIVE_PARTS = gql`
  mutation ReceiveMaterialAsync(
    $receiveReferenceId: String
    $trackingId: String!
    $receiveScanStartTime: Float!
    $receiveScanEndTime: Float!
    $clientToken: String
    $externalScannableId: String
    $receivedLineItemList: [ReceivedLineItem]
    $receivedBy: String
    $receiveMethodUserProvidedReason: String
    $inventoryAdjustmentUsageReason: String
    $siteName: String
    $category: String
    $receiveType: String
    $buildId: String
    $clusterName: String
    $siteEquipmentId: String
    $rmaId: String
  ) {
    receiveMaterialAsync(
      receiveReferenceId: $receiveReferenceId
      trackingId: $trackingId
      receiveScanStartTime: $receiveScanStartTime
      receiveScanEndTime: $receiveScanEndTime
      clientToken: $clientToken
      externalScannableId: $externalScannableId
      receivedLineItemList: $receivedLineItemList
      receivedBy: $receivedBy
      receiveMethodUserProvidedReason: $receiveMethodUserProvidedReason
      inventoryAdjustmentUsageReason: $inventoryAdjustmentUsageReason
      siteName: $siteName
      category: $category
      receiveType: $receiveType
      buildId: $buildId
      clusterName: $clusterName
      siteEquipmentId: $siteEquipmentId
      rmaId: $rmaId
    ) {
      receiveExecutionReadableId
      receiveExecutionStatus
      receiveExecutionUUId
    }
  }
`;
